module.exports = __webpack_public_path__ + "img/server_icon.bdd9cdd4.svg";